import TrackingPage from '@/pages/tracking/TrackingPage.vue'
import TrackingDetails from "@/pages/tracking/TrackingDetails.vue";
import TrackingBulkPage from "@/pages/tracking/TrackingBulkPage.vue";
import TrackingBulkDetails from "@/pages/tracking/TrackingBulkDetails.vue";
import TrackingForm from "@/pages/tracking/TrackingForm.vue";
import TrackingBulkForm from "@/pages/tracking/TrackingBulkForm.vue";

export default [
  {
    path: '/trackingdetails/:type/:id',
    component: TrackingDetails,
    props: true
  },
  {
    path: '/tracking/:type/:id',
    component: TrackingPage,
    props: true
  },
  {
    path: '/trackingform/create',
    component: TrackingForm,
    props: true
  },
  {
    path: '/trackingbulkform/create',
    component: TrackingBulkForm,
    props: true
  },
  {
    path: '/trackingbulk/',
    component: TrackingBulkPage,
    props: true
  },
  {
    path: '/trackingbulk/:id',
    component: TrackingBulkDetails,
    props: true
  }
]
